import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import axios from "axios";
import {
    Box,
    Button,
    Grid,
    Paper,
    ListItemText,
    ListItemSecondaryAction,
    Container,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    IconButton,
    List,
    ListItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    Divider,
} from "@material-ui/core";
import { ArrowForwardIos, PostAdd } from "@material-ui/icons";
import Layout from "../components/Layout/Layout";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        minWidth: 120,
        width: "100%",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    centered: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    userName: {
        flexGrow: 1,
        textAlign: "center",
    },
    menuButton: {
        padding: "0px",
    },
    margin: {
        margin: theme.spacing(1),
    },
    borderMargin: {
        margin: "5px",
    },
});

export class Mowing extends Component {
    static displayName = Mowing.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            privileges: this.props.crmPrivileges,
            currentUser: {
                id: props.match.params.hasOwnProperty("id") ? props.match.params.id : props.user.id,
                name: props.match.params.hasOwnProperty("name") ? props.match.params.name : props.user.name,
            },
            isAdminChecked: false,
            serviceType: "",
            employeeId: "",
            selProduct: "",
            serialFrom: "",
            serialTo: "",
            serviceSubTypes: [],
            selectedServiceSubType: [],
            serviceLinesTotal: "",
            serviceLinestStartingFrom: "",
            availableLists: [],
            selectedList: [],
            orginalProjectLines: [],
            filteredProjectLines: [],
            moveToListIsOpen: false,
            selectedProjectLine: [],
            availablePostalCodes: [],
            selectedPostalCode: [],
            selectedListToMove: [],
            selectedPostalCodeForImport: [],
            importPostalCodes: [],
            orderByAscending: true,
            importLoading: false,
            projectLines: [],
            employees: [],
            akkordtoday: 0,
        };
        //this.getWinterWorkSubscriptions();
        this.getEmployeeMowingProjectLines(this.state.currentUser.id);
    }

    componentDidMount() {
        this.setState({ loading: true });
    }

    handleAdminChange = (event) => {
        //on admin change we getemployees
        if (event.target.checked) {
            this.fetchEmployees();
            this.getMowingProducts();
        }

        this.setState({ isAdminChecked: event.target.checked });
    };

    getMowingProducts = () => {
        axios.get("/api/mowing/GetMowingProducts").then((res) => {
            const filteredArr = res.data;
            this.setState({ serviceType: "Sláttur", serviceSubTypes: filteredArr });
        });
    };

    getEmployeeMowingProjectLines = (empId) => {
        axios.get("/api/mowing/GetMowingProjectLinesForEmployee/" + empId).then((res) => {
            let projectLines = res.data;
            /*projectLines = projectLines.sort((a, b) => {
                return (a.serialNumber < b.serialNumber ? 1 : -1);
            });
            projectLines = projectLines.reverse();
            */
            /*
            const availableLists = projectLines
                .map(line => line.listId)
                .reduce((accumulator, current) => {
                    if (!accumulator.some(x => x === current)) {
                        accumulator.push(current);
                    }
                    return accumulator;
                }, [])
                .sort(function (a, b) {
                    return a - b;
                });

            const availablePostalCodes = projectLines
                .filter(line => line.listId === availableLists[0])
                .map(line => line.project.address.postalCode)
                .reduce((accumulator, current) => {
                    if (!accumulator.some(x => x === current)) {
                        accumulator.push(current);
                    }
                    return accumulator;
                }, [])
                .sort(function (a, b) {
                    return a - b;
                });

            const hasPostalCodeOrListInMemory = this.props.location.state != null && (this.props.location.state.selectedList != null || this.props.location.state.selectedPostalCode != null);

            if (hasPostalCodeOrListInMemory) {
                this.setState({
                    selectedList: this.props.location.state.selectedList,
                    selectedPostalCode: this.props.location.state.selectedPostalCode
                });
            } else {
                this.setState({
                    selectedList: availableLists[0],
                    selectedPostalCode: availablePostalCodes[0]
                });
            }
            */
            this.setState({
                loading: false,
                //availableLists,
                //availablePostalCodes,
                projectLines,
            });

            //No competing with list load so getting akkord here
            this.getEmployeeAkkordTotalToday(empId);
        });
    };

    getEmployeeAkkordTotalToday = (empId) => {
        axios.get("/api/mowing/GetEmployeeAkkord/" + empId).then((res) => {
            let akkord = res.data;
            this.setState({ akkordtoday: akkord });
        });
    };

    hasPrivilege = (privName) => {
        if (this.state.privileges.some((p) => p.name === privName)) {
            return true;
        } else {
            return false;
        }
    };

    handleListChange = (event) => {
        const selectedList = event.target.value;

        const availablePostalCodes = this.state.projectLines
            .filter((line) => line.listId === selectedList)
            .map((line) => line.project.address.postalCode)
            .reduce((accumulator, current) => {
                if (!accumulator.some((x) => x === current)) {
                    accumulator.push(current);
                }
                return accumulator;
            }, [])
            .sort(function (a, b) {
                return a - b;
            });

        this.setState({ selectedList, availablePostalCodes, selectedPostalCode: availablePostalCodes[0] });
    };

    handlePostalCodeChange = (event) => {
        const selectedPostalCode = event.target.value;
        this.setState({ selectedPostalCode });
    };

    handleMoveToList = (selectedProjectLine) => {
        this.setState({ moveToListIsOpen: true, selectedProjectLine });
    };

    handleCloseMoveToList = () => {
        this.setState({ moveToListIsOpen: false });
    };

    handleChangeListToMove = (event) => {
        const selectedList = event.target.value;

        if (selectedList != null) {
            this.setState({ selectedListToMove: selectedList });
            this.moveToList(selectedList);
        }
    };

    sortProjectLineList = () => {
        const orderTrigger = !this.state.orderByAscending;
        const reversed = this.state.projectLines.reverse((a, b) => {
            return a.serialNumber < b.serialNumber;
        });
        this.setState({ orderByAscending: orderTrigger, projectLines: reversed });
    };

    goToRoute = (line, props, state) => {
        props.history.push("/mowing/" + line.id, { selectedList: state.selectedList, selectedPostalCode: state.selectedPostalCode });
    };

    renderListItems = (line, isAdmin, primaryText, secondaryText, classes) => {
        const productName = line.product != null && line.product.name != null ? line.product.name : "Óskráð";
        const serialNumber = line.serialNumber != null ? line.serialNumber : "Óskráð";
        const addressName = line.project != null && line.project.address != null && line.project.address.name != null ? line.project.address.name : "Óskráð";
        const checkedIn = line.checkIn != null ? true : false;
        // const checkedOut = line.checkOut != null ? true : false;
        // const skipped = line.skipped;

        return (
            <Box key={line.id}>
                <ListItem style={{ padding: "0", borderLeft: checkedIn ? "6px solid #28a745" : "6px solid #b0b0b0" }} button>
                    <ListItemText
                        primary={addressName}
                        primaryTypographyProps={{ style: primaryText }}
                        secondary={productName + " - Serial: " + serialNumber}
                        secondaryTypographyProps={{ style: secondaryText }}
                        onClick={() => this.goToRoute(line, this.props, this.state)}
                        style={{ margin: "5px" }}
                    />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" onClick={() => this.goToRoute(line, this.props, this.state)}>
                            <ArrowForwardIos />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider component="li" />
            </Box>
        );
    };

    renderMain = (props) => {
        const { t } = props;
        const classes = props;
        const primaryText = {
            fontSize: "14px",
        };

        const secondaryText = {
            fontSize: "10px",
        };

        const isAdmin = this.hasPrivilege("Sláttur super");

        let projectLineListToDisplay = this.state.projectLines; //.filter(line => line.listId === this.state.selectedList && line.project.address.postalCode === this.state.selectedPostalCode);

        if (this.state.selectedPostalCode === "ShowAll") {
            projectLineListToDisplay = this.state.projectLines; //.filter(line => line.listId === this.state.selectedList);
        }
        /*
            <IconButton style={{ width: "100%" }} className={classes.menuButton} color="inherit" aria-label="OrderBy" onClick={this.sortProjectLineList}>
                {this.state.orderByAscending ? <ArrowDownward fontSize="small" /> : <ArrowUpward fontSize="small" />}
            </IconButton>
         */

        return (
            <div style={{ maxWidth: "100%" }}>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        {this.state.akkordtoday > 0 ? <span>Akkorð í dag: {this.state.akkordtoday} kr. </span> : ""}
                        <Grid container spacing={3} className={classes.centered}>
                            <Grid item xs={12}>
                                <div className={classes.root} style={{ maxHeight: "55vh", overflow: "auto" }}>
                                    <div>
                                        <List dense>
                                            {projectLineListToDisplay.map((line) => {
                                                return this.renderListItems(line, isAdmin, primaryText, secondaryText, classes);
                                            })}
                                        </List>
                                        <Dialog
                                            open={this.state.moveToListIsOpen}
                                            maxWidth={"lg"}
                                            fullWidth={true}
                                            onClose={this.handleCloseMoveToList}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{this.state.selectedProjectLine.name}</DialogTitle>
                                            <DialogContent style={{ height: "20vh" }}>
                                                <Paper className={classes.root}>
                                                    <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                                        <InputLabel id="demo-simple-select-outlined-label">Select a list to move to</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={this.state.selectedListToMove}
                                                            onChange={this.handleChangeListToMove}
                                                            label="Select a list to move to"
                                                        >
                                                            {this.state.moveToListIsOpen && this.state.availableLists.length > 0
                                                                ? this.state.availableLists
                                                                      .filter((listid) => {
                                                                          return listid !== this.state.selectedProjectLine.listId;
                                                                      })
                                                                      .map((listnumber) => (
                                                                          <MenuItem key={listnumber} value={listnumber}>
                                                                              Listi nr. {listnumber}
                                                                          </MenuItem>
                                                                      ))
                                                                : null}
                                                        </Select>
                                                    </FormControl>
                                                </Paper>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={this.handleCloseMoveToList} color="default" autoFocus>
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    };

    handleServiceTypeChange = (event) => {
        this.setState({ serviceType: event.target.value });
    };

    handleChangeMultiple = (event) => {
        this.setState({ selProduct: event.target.value });
    };

    handleServiceLinesTotalChange = (event) => {
        const input = event.target.value;
        this.setState({ serialFrom: input });
    };
    handleServiceLinesStartingFromChange = (event) => {
        const input = event.target.value;
        this.setState({ serialTo: input });
    };

    handlePostalCodeForImportChange = (event) => {
        this.setState({
            employeeId: event.target.value,
        });
    };

    importLists = (e, employee, selProduct, serialFrom, serialTo) => {
        this.setState({ importLoading: true });
        axios
            //.get("/api/mowing/AssignEmployeeMowingSubscriptionsProxy/"+employee+"/"+selProduct+"/"+serialFrom+"/"+serialTo)
            //, {
            //.post("https://gardlistazureappsdev.azurewebsites.net/api/AssignEmployeeMowingSubscriptions?code=zzkkg5Dg9jpLrdy11YO/RyZPc0fCWZU0b4QbFeBIsjZx6Sgat695dg==", {
            .post("/api/mowing/AssignEmployeeMowingSubscriptionsProxy", {
                EmployeeId: employee,
                Product: selProduct,
                SerialNumberFrom: serialFrom,
                SerialNumberTo: serialTo,
            })
            .then((res) => {
                this.props.enqueueSnackbar("Successfully ran query", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                //this.getEmployeeMowingProjectLines();

                this.setState({ importLoading: false });
            })
            .catch((err) => {
                this.props.enqueueSnackbar("Error occurred when importing list", {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ importLoading: false });
            });
    };

    fetchEmployees = () => {
        axios.get("/api/timeregistration/GetAllEmployees").then((res) => {
            const employees = res.data;
            this.setState({
                employees: employees,
                loading: false,
            });
        });
    };

    //The admin view for the Mowing (Sláttur)
    renderAdmin = (props) => {
        const { t } = props;
        const { classes } = props;
        const ITEM_HEIGHT = 48;
        const ITEM_PADDING_TOP = 8;
        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        };
        return (
            <Container style={{ maxWidth: "90%" }}>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        {this.state.importLoading ? (
                            <Grid container spacing={3} className={classes.centered} style={{ textAlign: "center" }}>
                                <Grid item xs={12}>
                                    <CircularProgress />
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container spacing={3} className={classes.centered}>
                                {this.state.employees.length > 0 ? (
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel shrink htmlFor="select-multiple-native">
                                                Employee
                                            </InputLabel>
                                            <Select
                                                native
                                                onChange={this.handlePostalCodeForImportChange}
                                                inputProps={{
                                                    id: "select-native",
                                                }}
                                            >
                                                <option key="" value="">
                                                    --Veldu starfsmann--
                                                </option>
                                                {this.state.employees.map((emp) => (
                                                    <option key={emp.id} value={emp.id}>
                                                        {emp.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                ) : null}
                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel shrink htmlFor="select-multiple-native">
                                            Products
                                        </InputLabel>
                                        <Select
                                            native
                                            labelId="mutiple-checkbox-label"
                                            //value={this.state.selProduct}

                                            onChange={this.handleChangeMultiple}
                                            inputProps={{
                                                id: "select-native",
                                            }}
                                        >
                                            <option key="" value="">
                                                --Veldu vöru--
                                            </option>
                                            {this.state.serviceSubTypes.map((emp) => (
                                                <option key={emp.productNumber} value={emp.productNumber}>
                                                    {emp.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl}>
                                        <TextField id="filled-number" label="Number from" type="number" fullWidth value={this.state.serialFrom} onChange={this.handleServiceLinesTotalChange} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl}>
                                        <TextField id="filled-number" label="Number to" type="number" fullWidth value={this.state.serialTo} onChange={this.handleServiceLinesStartingFromChange} />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControl className={classes.formControl}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={classes.button}
                                            endIcon={<PostAdd>EXECUTE</PostAdd>}
                                            onClick={(e) => this.importLists(e, this.state.employeeId, this.state.selProduct, this.state.serialFrom, this.state.serialTo)}
                                        >
                                            Execute
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </Container>
        );
    };

    render = () => {
        let contents = this.state.loading ? (
            <Grid container spacing={3} style={{ textAlign: "center" }}>
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            </Grid>
        ) : this.state.isAdminChecked ? (
            this.renderAdmin(this.props)
        ) : (
            this.renderMain(this.props)
        );

        const { classes, t } = this.props;

        const isAdmin = this.hasPrivilege("Sláttur super");

        return (
            <Layout title={t("Mowing")} subtitle={this.state?.currentUser?.name ?? ""} color="rgb(75 113 23)" isAdmin={isAdmin} onAdminToggle={this.handleAdminChange}>
                <Container>{contents}</Container>
            </Layout>
        );
    };
}

export default withSnackbar(withStyles(styles)(withTranslation()(withRouter(Mowing))));
